import API from "Api";
import { generateDynamicEndpoint } from "utils/generalUtils";
import {
  GET_SURGERY_LIST_ENDPOINT,
  CREATE_SURGERY_ENDPOINT,
  UPDATE_SURGERY_ENDPOINT,
  DELETE_SURGERY_ENDPOINT,
  GET_DRIVER_FIELD_ENDPOINT,
  GET_SINGLE_SURGERY_ENDPOINT,
  GET_WORKING_DAY_ENDPOINT,
  GET_SURGERY_NOTE_LIST_ENDPOINT,
  CREATE_SURGERY_NOTE_ENDPOINT,
  UPDATE_SURGERY_NOTE_ENDPOINT,
  GET_SINGLE_SURGERY_NOTE_ENDPOINT,
  DELETE_SURGERY_NOTE_ENDPOINT,
  UPDATE_SURGERY_FIELD_ENDPOINT,
  CREATE_SURGERY_MULTIPLE,
} from "./endpoints";

//Get staff List
export const getSurgeryListAPI = (payload) => {
  return API.post(GET_SURGERY_LIST_ENDPOINT, payload);
};

// Create staff
export const createSurgeryAPI = (payload) => {
  return API.post(CREATE_SURGERY_ENDPOINT, payload);
};
// Create multiple sstaff
export const createSurgeryMultipleAPI = (payload) => {
  return API.post(CREATE_SURGERY_MULTIPLE, payload);
};

//Update staff
export const updateSurgeryAPI = (id, payload) => {
  return API.put(
    generateDynamicEndpoint(UPDATE_SURGERY_ENDPOINT, { surgery_id: id }),
    payload
  );
};
export const updateFieldAPI = (id, payload) => {
  return API.put(
    generateDynamicEndpoint(UPDATE_SURGERY_FIELD_ENDPOINT, { id: id }),
    payload
  );
};

//Delete staff
export const deleteSurgeryAPI = (id) => {
  return API.deleteM(
    generateDynamicEndpoint(DELETE_SURGERY_ENDPOINT, { surgery_id: id })
  );
};

//
export const getSingleSurgery = (id) => {
  return API.get(
    generateDynamicEndpoint(GET_SINGLE_SURGERY_ENDPOINT, { surgery_id: id })
  );
};

//Driver List

export const getDriverListAPI = (payload) => {
  return API.post(GET_DRIVER_FIELD_ENDPOINT, payload);
};

//Working Day List
export const getWorkingDayListAPI = (payload) => {
  return API.post(GET_WORKING_DAY_ENDPOINT, payload);
};

//Get surgery note List
export const getPatientNoteListAPI = (payload) => {
  return API.post(GET_SURGERY_NOTE_LIST_ENDPOINT, payload);
};

// Create note api
export const createSurgeryNoteAPI = (payload) => {
  return API.post(CREATE_SURGERY_NOTE_ENDPOINT, payload);
};

//Update surgery note
export const updateSurgeryNoteAPI = (id, payload) => {
  return API.put(
    generateDynamicEndpoint(UPDATE_SURGERY_NOTE_ENDPOINT, { note_id: id }),
    payload
  );
};

//single note api
export const getSingleSurgeryNoteAPI = (id) => {
  return API.get(
    generateDynamicEndpoint(GET_SINGLE_SURGERY_NOTE_ENDPOINT, {
      note_id: id,
    })
  );
};

//Delete surgery note
export const deleteSurgeryNoteAPI = (id) => {
  return API.deleteM(
    generateDynamicEndpoint(DELETE_SURGERY_NOTE_ENDPOINT, { note_id: id })
  );
};
